import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { EmpresaService } from "../empresa.service";
import { AdminService } from "src/app/modules/admin/admin.service";
import { HelperService } from "src/app/utils/helper.service";
import { SnackBarService } from "src/app/services/snack-bar.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Empresa } from "src/app/modules/admin/models/Empresa";
import { Endereco } from "src/app/modules/admin/models/Endereco";

@Component({
  selector: 'app-edit-empresa',
  templateUrl: './edit-empresa.component.html',
  styleUrls: ['./edit-empresa.component.css']
})
export class EditEmpresaComponent implements OnInit {

  empresaForm: FormGroup;
  orgao = false;
  loading = false;
  empresa: Empresa;

  constructor(
    public dialogRef: MatDialogRef<EditEmpresaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private empresaService: EmpresaService,
    public helper: HelperService,
    private snackBar: SnackBarService,
    private fb: FormBuilder
  ) {  }

  ngOnInit(): void {
    this.empresaForm = this.fb.group({
      cnpj: [{ value: null, disabled: true }],
      nome_fantasia: [null, Validators.required],
      razao_social: [null, Validators.required],
      email: [null, Validators.required],
      telefone: [null, Validators.required],
      cep: [null, Validators.required],
      logradouro: [null, Validators.required],
      numero: [null, Validators.required],
      complemento: [null, Validators.required],
      bairro: [null, Validators.required],
      cidade: [null, Validators.required],
      municipio: [null, Validators.required],
      uf: [null, Validators.required],
      nome: [null, Validators.required],
      cpf: [null, Validators.required],
      tipo: [null, Validators.required],
      email_representante: [null, Validators.required],
      tel_representante: [null, Validators.required],
    });
    this.empresaService.buscaEmpresa(this.data)
      .subscribe((res: Empresa) => {
        this.empresa = res;
        this.loading = false;
      },
    error => {
      this.loading = false;
      this.snackBar.showSnackBarError('Erro ao carregar dados da empresa');
      console.error(error);
      this.dialogRef.close();
    })
  }

  loadEmpresaData(data) {
    this.empresaForm.patchValue(data);
  }

  private parseTelefone(telefone: string) {

    const numeros = telefone.replace(/\D/g, '');

    return {
      ddd: numeros.substring(0, 2),
      telefone: numeros.substring(2)
    };

  }

  closeDialog() {
    const telefone = this.parseTelefone(this.empresaForm.value.telefone);
    const tel_representante = this.parseTelefone(this.empresaForm.value.tel_representante);

    this.dialogRef.close({
      id: this.empresa.id,
      cnpj: this.empresa.cnpj,
      nome_fantasia: this.empresaForm.value.nome_fantasia,
      razao_social: this.empresaForm.value.razao_social,
      contatos:
        [
          {
            email: this.empresaForm.value.email,
            ddd: telefone.ddd,
            telefone: telefone.telefone,
          },
        ],
      enderecos:
        [
          {
            cep: this.empresaForm.value.cep,
            logradouro: this.empresaForm.value.logradouro,
            numero: this.empresaForm.value.numero,
            complemento: this.empresaForm.value.complemento,
            bairro: this.empresaForm.value.bairro,
            cidade: this.empresaForm.value.cidade,
            municipio: this.empresaForm.value.municipio,
            uf: this.empresaForm.value.uf,
          },
        ],
      representantes:
        [
          {
            nome: this.empresaForm.value.nome,
            cpf: this.empresaForm.value.cpf,
            tipo: this.empresaForm.value.tipo,
            contatos:
            [
              {
                email: this.empresaForm.value.email_representante,
                ddd: tel_representante.ddd,
                telefone: tel_representante.telefone,
              }
            ],
          }
        ]
    });
  }

  setEndereco(endereco: Endereco) {

  }
}
